import Stats from '@/views/stats/Stats';
export default [
    {
        path: '/stats',
        name: 'stats',
        meta: {
          tab: {
              name: '统计',
              icon: 'icon icon-icon_statistics',
              iconActive: 'icon icon-icon_statistics_fill',
          }
        },
        component: Stats
    }
]